var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58203 2.43652H6.33203C7.17188 2.43652 7.97734 2.77015 8.5712 3.36402C9.16507 3.95788 9.4987 4.76334 9.4987 5.60319V16.6865C9.4987 16.0566 9.24848 15.4525 8.80308 15.0071C8.35768 14.5617 7.75359 14.3115 7.1237 14.3115H1.58203V2.43652Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 2.43652H12.6667C11.8268 2.43652 11.0214 2.77015 10.4275 3.36402C9.83363 3.95788 9.5 4.76334 9.5 5.60319V16.6865C9.5 16.0566 9.75022 15.4525 10.1956 15.0071C10.641 14.5617 11.2451 14.3115 11.875 14.3115H17.4167V2.43652Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.e364b91267e969fdcfe5510bfacb24f3.svg";
export { ForwardRef as ReactComponent };